/* @flow */

import React from 'react';
import { Prompt } from 'react-router-dom';

type Props = {
  visible: boolean,
};

const PendingChangesPrompt = ({ visible }: Props) => (
  <Prompt
    when={visible}
    message={`
    Vous avez des modifications non enregistrées.
    Êtes-vous sûr(e) de vouloir quitter ?
    `}
  />
);

export default PendingChangesPrompt;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/PendingChangesPrompt.js